import React from 'react';

export default function LoginPage({ authForm = {}, handleAuthChange = () => {}, handleLogin = () => {}, switchToRegister = () => {}, error }) {
  return (
    <div className="auth-page">
      <h2>Login</h2>
      <form className="auth-form" onSubmit={handleLogin}>
        <label htmlFor="login-email" className="sr-only">Email address</label>
        <input 
          id="login-email"
          name="email" 
          type="email"
          placeholder="Email" 
          value={authForm.email || ''} 
          onChange={handleAuthChange}
          autoComplete="email"
          required
          aria-required="true"
        />
        <label htmlFor="login-password" className="sr-only">Password</label>
        <input 
          id="login-password"
          name="password" 
          type="password" 
          placeholder="Password" 
          value={authForm.password || ''} 
          onChange={handleAuthChange}
          autoComplete="current-password"
          required
          aria-required="true"
        />
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button className="primary" type="submit">Login</button>
          <button type="button" className="small" onClick={switchToRegister}>Register</button>
        </div>
        {error && <div className="error" role="alert">{error}</div>}
      </form>
    </div>
  );
}
